import { AuthorizedContent } from '@frontegg/react';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Grid } from '@mui/material';
import React, { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import useSWR from 'swr';
import { useLanguage } from '../../contexts/languageContext';
import { TenantContext } from '../../contexts/tenantContext';
import { colors } from '../../theme';
import { LogoStyled } from '../../theme/style';
import RolesType from '../../utils/enum/RolesType';
import useFetcher from '../../utils/hooks/useFetcher';
import isElementVisible from '../../utils/isElementVisible';
import { SurveyProps } from '../Survey/surveyInterface';
import DropdownTenantMenu from './DropdownTenantMenu/dropdownTenantMenu';
import DropdownTranslateMenu from './DropdownTranslateMenu/dropdownTranslateMenu';
import DropdownUser from './DropdownUserMenu/dropdownUserMenu';
import { AppBarStyled, LinkStyled, FlexBox, ButtonHeaderStyled } from './styled';

const Header: FC = () => {
    const location = useLocation();
    const { t, i18n } = useTranslation('navigation');
    const [hasHotAlert, setHasHotAlert] = useState<boolean>(false);
    const locationSplit = location.pathname.split('/');
    const linkToHotAlert = `/survey/${locationSplit[2]}/hot-alerts/`;
    const [selectedSchema] = useContext(TenantContext)!;
    const fetcher = useFetcher();
    const { data: SurveysConfig } = useSWR([`${process.env.REACT_APP_API_URL}/survey`, selectedSchema], fetcher);
    const { selectedLanguage, availableLanguages, setSelectedLanguage } = useLanguage();

    useEffect(() => {
        if (locationSplit[2] && SurveysConfig) {
            const SurveyConfig = SurveysConfig.filter((element: SurveyProps) => element.surveyid === Number(locationSplit[2]))[0];
            if (SurveyConfig) {
                setHasHotAlert(SurveyConfig.hotAlertCount > 0);
            }
        }
    }, [locationSplit, SurveysConfig]);

    useEffect(() => {
        if (selectedLanguage) {
            i18n.changeLanguage(selectedLanguage.code);
        }
    }, [selectedLanguage]);

    const handleLanguageChange = (languageId: number) => {
        const selectedLang = availableLanguages.find((lang) => lang.id === languageId);
        if (selectedLang) {
            setSelectedLanguage(selectedLang);
        }
    };

    return (
        <AppBarStyled position="static">
            <Grid alignItems="center" justifyContent="center" container>
                <FlexBox justifyContent='flex-start'>
                    <Link style={{ display: 'flex' }} to="/">
                        <LogoStyled />
                    </Link>
                    {isElementVisible(location.pathname, '/') && (
                        <ButtonHeaderStyled startIcon={<KeyboardArrowLeftIcon />} disableRipple>
                            <LinkStyled
                                to="/"
                                underline="none"

                            >
                                {t('backToHome')}
                            </LinkStyled>
                        </ButtonHeaderStyled>
                    )}
                </FlexBox>
                <FlexBox justifyContent='flex-end'>
                    <AuthorizedContent requiredRoles={[RolesType.ADMIN, RolesType.ADMIN_MOAI, RolesType.VIEWER_DASHBOARD]}>
                        {((locationSplit.includes('dashboard') && locationSplit.includes('survey')) && hasHotAlert) && (
                            <Link to={linkToHotAlert}>
                                <ButtonHeaderStyled
                                    colorfont={location.pathname === '/hot-alerts' ? colors.default : colors.grey300}
                                    disableRipple
                                >
                                    {t('hotAlert')}
                                </ButtonHeaderStyled>
                            </Link>
                        )}
                    </AuthorizedContent>
                    <DropdownTenantMenu />
                    {selectedLanguage && (<DropdownTranslateMenu handleLanguageChange={handleLanguageChange} selectedLanguageId={selectedLanguage.id} tenantLanguages={availableLanguages} />)}
                    <DropdownUser />
                </FlexBox>
            </Grid>
        </AppBarStyled>
    );
};

export default Header;
